import React, { useEffect, useState } from "react";
import { formatNumberToShortForm, getCurrentCustomerCount } from "~/lib/helpers/StringHelper";

type CounterProps = {
  end: number;
  duration?: number;
  label: string;
  addPlus?: boolean;
};


const Counter: React.FC<CounterProps> = ({ end, duration = 2000, label, addPlus = false, isMobile = false }) => {
  const [count, setCount] = useState(0);


  useEffect(() => {
    let start = 0;
    const increment = end / (duration / 16);
    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        clearInterval(timer);
        setCount(end);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);

    return () => clearInterval(timer);
  }, [end, duration]);

  return (
    <div className="flex flex-col items-center">
      <span className="text-4xl font-bold text-gray-800">
        {count.toLocaleString()}{addPlus ? "+" : ""}
      </span>
      <span className="text-sm text-gray-500">{label}</span>
    </div>
  );
};
let customerCount = getCurrentCustomerCount({ isFormatted: false }) || 500000;



export default function StatsCounter({ isMobile }: { isMobile?: boolean }) {
  return (
    <div className="w-full py-8 md:py-12 bg-white px-6 md:px-4">
      <div className="max-w-5xl mx-auto">
        {isMobile ? (
          <div className="flex flex-col gap-4">
            <div className="bg-gray-50 rounded-2xl py-6 px-4 text-center border border-gray-200 shadow-[0_0_10px_rgba(0,0,0,0.08)]">
              <Counter
                isMobile={isMobile}
                end={customerCount}
                label="Customers Since 2014"
                addPlus={true}
              />
            </div>

            <div className="bg-gray-50 rounded-2xl py-6 px-4 text-center border border-gray-200 shadow-[0_0_10px_rgba(0,0,0,0.08)]">
              <Counter
                isMobile={isMobile}
                end={349000}
                label="Office Listings"
              />
            </div>

            <div className="bg-gray-50 rounded-2xl py-6 px-4 text-center border border-gray-200 shadow-[0_0_10px_rgba(0,0,0,0.08)]">
              <Counter
                isMobile={isMobile}
                end={110}
                label="Countries Covered"
              />
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-3 gap-8 text-center">
            <Counter
              isMobile={isMobile}
              end={customerCount}
              label="Customers Since 2014"
              addPlus={true}
            />
            <Counter
              isMobile={isMobile}
              end={349000}
              label="Office Listings"
            />
            <Counter
              isMobile={isMobile}
              end={110}
              label="Countries Covered"
            />
          </div>
        )}
      </div>
    </div>
  );
}